<app-admin-form [title]="'Autokeuze instellingen'" [object]="settings" [withSettingsSelector]="true" (settingsChanged)="settings=$event">
  <app-admin-checkbox [label]="'Mededeling actief'" [(model)]="settings.MededelingOnderAutokeuze">
  </app-admin-checkbox>
  <app-admin-editor [label]="'Mededeling'" [(model)]="settings.MededelingOnderAutokeuzeHtml"></app-admin-editor>
  <app-admin-editor [label]="'Mededeling autoselectie in header'" [(model)]="settings.NotificationWhenCarTypeSelectionInHeader"></app-admin-editor>
  <app-admin-cancel-save-button [saveAction]="adminSettingsService.saveSettingsCarType(settings)">
  </app-admin-cancel-save-button>
</app-admin-form>
